import dayjs from 'dayjs';
import { DraftDocument, MetadataErrors, MetadataValues } from './types';

// The "Saisir les données" form (Step2Metadata) is shared by the wizard
// and "Modifier le document": the validation and the loading of values go here
// so that both apply the same rule.

// Required (the XD does not mark them): Titre, Date d'émission and Émetteur. The
// date and the issuer are required by the backend to archive; the title is what
// the listings show.
export const validateMetadata = (values: MetadataValues): MetadataErrors => {
  const errors: MetadataErrors = {};
  if (!values.title.trim()) errors.title = 'Le titre est obligatoire.';
  if (!values.issuingDate) {
    errors.issuingDate = "La date d'émission est obligatoire.";
  } else if (!values.issuingDate.isValid()) {
    errors.issuingDate = "La date d'émission n'est pas valide.";
  } else if (values.issuingDate.isAfter(dayjs(), 'day')) {
    errors.issuingDate = "La date d'émission ne peut pas être dans le futur.";
  }
  if (!values.issuer.trim()) errors.issuer = "L'émetteur est obligatoire.";
  return errors;
};

// What the document already has. The date arrives as UTC midnight; the
// calendar day is taken so as not to shift it.
export const metadataValuesFrom = (document: DraftDocument): MetadataValues => ({
  title: document.title ?? '',
  issuingDate: document.issuing_date
    ? dayjs(String(document.issuing_date).slice(0, 10))
    : null,
  service: document.service ?? '',
  issuer: document.issuer ?? '',
  confidential: Boolean(document.confidential),
});
